/** 新闻动态 — 静态内容，可按需扩展 */

export const newsCategories = [
  { id: 'all', label: '全部' },
  { id: 'company', label: '公司新闻' },
  { id: 'product', label: '产品动态' },
  { id: 'cooperation', label: '合作案例' },
  { id: 'video', label: '公司视频' },
]

export const newsArticles = [
  {
    id: 'brochure-2026',
    category: 'company',
    date: '2026-01-15',
    title: '天津高仁科技 2026 企业宣传册正式发布',
    summary:
      '全新宣传册涵盖系统类、教育类、机器人类、AGV类、非标自动化五大产品线，以及智慧用电与光伏云平台完整功能展示。',
    image: '/images/pdf-pages/gaoren-01.png',
    featured: true,
  },
  {
    id: 'smart-power-cloud',
    category: 'product',
    date: '2025-11-20',
    title: '智慧用电云平台功能模块全面升级',
    summary:
      '用电监测、能耗分析、同比环比报表、自定义饼图、四象限分析等功能界面完成迭代，支持私有化部署与本地运维。',
    image: '/images/systems/power-curve.png',
    featured: true,
  },
  {
    id: 'pv-cloud-launch',
    category: 'product',
    date: '2025-09-08',
    title: '智慧光伏云平台正式上线',
    summary:
      '覆盖光伏大屏、逆变器数据、网关管理、报警中心、服务器监控等模块，助力新能源场站数字化运维。',
    image: '/images/systems/pv-dashboard.png',
    featured: false,
  },
  {
    id: 'vocational-cooperation',
    category: 'cooperation',
    date: '2025-06-12',
    title: '与多所职业院校共建实训基地',
    summary:
      '围绕智能制造产线、工业机器人技能实训、数字孪生等方向，为院校提供设备、课程与竞赛一体化解决方案。',
    image: '/images/competition-training.png',
    featured: false,
  },
  {
    id: 'competition-support',
    category: 'cooperation',
    date: '2025-04-18',
    title: '世界职业院校技能大赛技术支持服务',
    summary:
      '提供赛项设备改造、原创平台定制开发与专家团队指导，助力院校竞赛训练与成果转化。',
    image: '/images/news-smart-factory.png',
    featured: false,
  },
  {
    id: 'agv-custom',
    category: 'product',
    date: '2025-02-25',
    title: 'AGV 与复合机器人定制方案交付',
    summary:
      '潜伏顶升、叉车 AGV、复合机器人等多形态移动机器人方案，支持仓储物流与柔性制造场景。',
    image: '/images/forklift-agv.png',
    featured: false,
  },
  {
    id: 'company-video-intro',
    category: 'video',
    date: '2025-01-10',
    title: '高仁科技企业介绍视频',
    summary: '了解天津高仁科技的发展历程、核心能力与典型应用场景。',
    image: '/images/hero-bottom-lineup.png',
    featured: false,
    isVideo: true,
  },
  {
    id: 'humanoid-demo',
    category: 'video',
    date: '2024-11-05',
    title: '人型机器人应用场景演示',
    summary: '展示人型机器人在服务展示、科研教学等场景的应用潜力。',
    image: '/images/humanoid-service.png',
    featured: false,
    isVideo: true,
  },
]

export function getNewsByCategory(categoryId) {
  if (!categoryId || categoryId === 'all') return newsArticles
  return newsArticles.filter((item) => item.category === categoryId)
}

export function getFeaturedNews(limit = 3) {
  return newsArticles.filter((item) => item.featured).slice(0, limit)
}
